import React, { FC } from 'react';
import { X } from 'react-bootstrap-icons';
import Accordion from 'react-bootstrap/Accordion';

import { DivFilterBox, ButtonClose, DivContent, DivFooter, H3Title } from './styles';
import {
  TCurrentFilter,
  TCurrentTextBox,
  TCurrentTextBoxIsLoadingState,
  TGroupedFilter
} from '../../../../commonTypes/filters';
import { AccordionCardBlock } from '../AccordionCardBlock/index';
import FnButton from '../../../../components/elements/FnButton/index';
import { FnButtonSizes, FnButtonTypes, FnButtonVariants } from '../../../../components/elements/FnButton/constants';
import { TActiveQuickFilter } from '@features/Filters/redux/types';

interface Props {
  className: string;
  onSwitchFilter: () => void;
  onClearAllFilters: () => void;
  filters: TGroupedFilter[];
  currentFilterItems: TCurrentFilter[];
  currentTextBoxItems: TCurrentTextBox[];
  isLoadingStates: TCurrentTextBoxIsLoadingState[];
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
  onClearCurrentTextBoxValues: (data: string[]) => void;
  onFetchDataTextBoxFilterAction: (internalName: string, searchValue: string) => void;
  onFetchCancel: (internalName: string) => void;
  onSetActiveQuickFilter?: (data: TActiveQuickFilter) => void;
  activeQuickFilters?: TActiveQuickFilter;
  showColor?: boolean;
}

export const FilterBox: FC<Props> = ({
  className,
  onSwitchFilter,
  onClearAllFilters,
  onSetFilter,
  onClearFilter,
  onClearCurrentTextBoxValues,
  onFetchDataTextBoxFilterAction,
  onFetchCancel,
  filters,
  currentFilterItems,
  currentTextBoxItems,
  isLoadingStates,
  onSetActiveQuickFilter = null,
  activeQuickFilters = null,
  showColor = false
}) => (
  <DivFilterBox className={className}>
    <ButtonClose variant="light" className="filter-btn-close" onClick={onSwitchFilter}>
      <X size={20} />
    </ButtonClose>
    <H3Title className="filter-title">Filter</H3Title>
    <DivContent>
      <Accordion defaultActiveKey="0">
        {filters.map((item: TGroupedFilter) => (
          <AccordionCardBlock
            key={item.order}
            data={item}
            currentFilterItems={currentFilterItems}
            currentTextBoxItems={currentTextBoxItems}
            isLoadingStates={isLoadingStates}
            onSetFilter={onSetFilter}
            onClearFilter={onClearFilter}
            onClearCurrentTextBoxValues={onClearCurrentTextBoxValues}
            onFetchDataTextBoxFilterAction={onFetchDataTextBoxFilterAction}
            onFetchCancel={onFetchCancel}
            onSetActiveQuickFilter={onSetActiveQuickFilter}
            activeQuickFilters={activeQuickFilters}
            showColor={showColor}
          />
        ))}
      </Accordion>
    </DivContent>
    <DivFooter>
      <FnButton
        size={FnButtonSizes.Small}
        viewType={FnButtonTypes.Text}
        text="Clear All Filters"
        onClick={onClearAllFilters}
      />
      <FnButton
        size={FnButtonSizes.Small}
        viewType={FnButtonTypes.Default}
        variant={FnButtonVariants.Secondary}
        text="Done"
        onClick={onSwitchFilter}
      />
    </DivFooter>
  </DivFilterBox>
);
